import React, { useState, useEffect, useRef, useMemo } from 'react';
import '../../css/seeMovements.css';
import '../../css/customModalMovementsInfo.css'
import PlaceholderLoading from 'react-placeholder-loading';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import { useNavigate } from 'react-router-dom';
import { useMobileMediaQuery, useUltraMobileMediaQuery, useTabletMediaQuery, currencyFormat } from '../../utils';
import CustomButton from '../../components/CustomButton';
import ImgMovSaldoDispSvg from '../../assets/svg/iconMovSaldoDisp.svg';
import ImgMovAcumuladoSempreSvg from '../../assets/svg/iconMovAcumuladoSempre.svg';
import ImgMovOndeMaisAcumulouSvg from '../../assets/svg/iconMovOndeMaisAcumulou.svg';
import ImgNoMovementsDataSvg from '../../assets/svg/iconNoMovementsData.svg';
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';
import CustomDatePicker from '../../components/CustomDatePicker';
import DatePresets from '../../components/DatePresets';
import moment from 'moment';
import 'moment/locale/pt';
import Heading from '../../components/Heading';
import { TextField, GlobalStyles } from '@mui/material';
import { styled } from '@mui/material/styles';
import { FaAngleRight } from "react-icons/fa6";
import { GoDotFill } from "react-icons/go";
import { IoMdInformationCircleOutline } from "react-icons/io";
import useCodes from '../../hooks/useCodes';
import CustomModalMovementsInfo from '../../components/CustomModalMovementsInfo';
import { IoMdClose } from "react-icons/io";
import GifAnim from '../../components/GifAnim';
import { useDispatch, useSelector } from 'react-redux';
import { setSessionId, setCookieId } from '../../features/onboardingData/onboardingUserData';
import ListPagination from '../../components/ListPagination';
import CustomButtonSelectOptionView from '../../components/CustomButtonSelectOptionView';
import CustomButtonSelectOption from '../../components/CustomButtonSelectOption';
import { errorHandling } from '../../utils';
import SuspendedWalletAlert from '../../components/SuspendedWalletAlert';
import CustomBreadcrumbs from '../../components/Breadcrumbs/CustomBreadcrumbs';

function SeeMovements() {

    const [isLoading, setIsLoading] = useState(true);
    const isSessionId = useSelector((state) => state.onboardingUserData.isSessionId);
    const isCookieId = useSelector((state) => state.onboardingUserData.isCookieId);
    const isStatusCarteira = useSelector((state) => state.onboardingUserData.isStatusCarteira);
    const navigate = useNavigate();
    const isMobile = useMobileMediaQuery();
    const isUltraMobile = useUltraMobileMediaQuery();
    const isTablet = useTabletMediaQuery();
    const [isAccumulatedBalance, setIsAccumulatedBalance] = useState(false);
    const [isBalanceSpent, setIsBalanceSpent] = useState(false);
    const [isBalanceOfCodesAndCampaigns, setIsBalanceOfCodesAndCampaigns] = useState(false);
    const [isPressedItem, setIsPressedItem] = useState(false)
    const dateFormat = "DD/MM/YYYY";
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [showAlertInfo, setShowAlertInfo] = useState(false);
    const [openMovementsInfoModal, setOpenMovementsInfoModal] = useState(false);
    const [openSelectFilteModal, setOpenSelectFilteModal] = useState(false);
    const today = moment();
    const { paymentTypeList, getPaymentType, paymentStatusList, getPaymentStatus } = useCodes();
    const [listaMovimentosResp, setListaMovimentosResp] = useState();
    const [listaMovimentosPendResp, setListaMovimentosPendResp] = useState();
    const [saldoDisp, setSaldoDisp] = useState('');
    const [saldoPend, setSaldoPend] = useState('');
    const [saldoAcum, setSaldoAcum] = useState('');
    const [saldoTopAcum, setSaldoTopAcum] = useState('');
    const [saldoTopAcumDesc, setSaldoTopAcumDesc] = useState('');
    const [filtroAcumulado, setFiltroAcumulado] = useState('');
    const [filtroGasto, setFiltroGasto] = useState('');
    const [filtroCodigo, setFfiltroCodigo] = useState('');
    const [numeroDePaginasMov, setNumeroDePaginasMov] = useState('');
    const [numeroDePaginasPend, setNumeroDePaginasPend] = useState('');
    const [numeroDeOcorrenciasMov, setNumeroDeOcorrenciasMov] = useState('');
    const [numeroDeOcorrenciasPend, setNumeroDeOcorrenciasPend] = useState('');
    const [pagMov, setPagMov] = useState(1);
    const [pagPend, setPagPend] = useState(1);
    const [selectedOption, setSelectedOption] = useState('M');
    const options = ['M', 'P'];
    const optionText = ['Movimentos', 'Pendentes'];
    const alertRef = useRef(null);
    
    const handleOptionClick = (option) => {
        setSelectedOption(option);
    };

    const getConsultaMovimentos = async () => {
        try {
          const response = await fetch(`${process.env.REACT_APP_DEV_URL}/consultaMovimentos/fetchConsultaMovimentos`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept-Language': 'PT-PT',
                'CookieId': `${isCookieId}`,
                'SessionId': `${isSessionId}`,
                'dataInicio': `${startDate === null ? startDate : moment(startDate).format('YYYY-MM-DD')}`,
                'dataFim': `${endDate === null ? endDate : moment(endDate).format('YYYY-MM-DD')}`,
                'iAcumulado': `${isAccumulatedBalance}`,
                'iGasto': `${isBalanceSpent}`,
                'iCodigo': `${isBalanceOfCodesAndCampaigns}`,
                'pagMov': `${pagMov}`,
                'pagPend': `${pagPend}`,
            },
            });
            if (response.ok === false) {
                errorHandling(response.status);
                return;
            }
            const result = await response.json();
            if (result.error.erroMsg === 'Success') {
                setSaldoDisp(currencyFormat(result.saldoDisp));
                setSaldoPend(currencyFormat(result.saldoPend));
                setSaldoAcum(currencyFormat(result.saldoAcum));
                setSaldoTopAcum(currencyFormat(result.saldoTopAcum));
                setSaldoTopAcumDesc(currencyFormat(result.saldoTopAcumDesc));
                setFiltroAcumulado(result.filtroAcumulado);
                setFiltroGasto(result.filtroGasto);
                setFfiltroCodigo(result.filtroCodigo);
                setListaMovimentosResp(result.listaMovimentos);
                setListaMovimentosPendResp(result.listaMovimentosPend);
                setNumeroDePaginasMov(result.numeroDePaginasMov);
                setNumeroDePaginasPend(result.numeroDePaginasPend);
                setNumeroDeOcorrenciasMov(result.numeroDeOcorrenciasMov);
                setNumeroDeOcorrenciasPend(result.numeroDeOcorrenciasPend);
            }
        } catch (error) {
            if (!navigator.onLine) {
                errorHandling('NoInternet');
            } else if (error instanceof TypeError && error.message === "Failed to fetch") {
                errorHandling('CORS');
            } else {
                errorHandling();
            }
        }
    }

    const processedItems = useMemo(() => {
        let lastDate = null;
        return listaMovimentosResp?.map((item) => {
            const currentDate = moment(item.movData).format('LL');
            const shouldDisplayDate = currentDate !== lastDate;
            
            if (shouldDisplayDate) {
                lastDate = currentDate;
            }
            
            return {
                ...item,
                shouldDisplayDate,
                formattedDate: currentDate
            };
        });
    }, [listaMovimentosResp]);

    const processedItemsPend = useMemo(() => {
        let lastDate = null;
        return listaMovimentosPendResp?.map((item) => {
            const currentDate = moment(item.movData).format('LL');
            const shouldDisplayDate = currentDate !== lastDate;
            
            if (shouldDisplayDate) {
                lastDate = currentDate;
            }
            
            return {
                ...item,
                shouldDisplayDate,
                formattedDate: currentDate
            };
        });
    }, [listaMovimentosPendResp]);

    useEffect(() => {
        getConsultaMovimentos();
    }, [(startDate, endDate), isAccumulatedBalance, isBalanceOfCodesAndCampaigns, isBalanceSpent, pagMov, pagPend]);

    useEffect(() => {
        setPagMov(1);
        setPagPend(1);
    }, [startDate, endDate]);

    const handleCheckboxChangeOne = () => {
        setIsAccumulatedBalance(!isAccumulatedBalance);
        setPagMov(1);
        setPagPend(1);
    };

    const handleCheckboxChangeTwo = () => {
        setIsBalanceSpent(!isBalanceSpent);
        setPagMov(1);
        setPagPend(1);
    };

    const handleCheckboxChangeThree = () => {
        setIsBalanceOfCodesAndCampaigns(!isBalanceOfCodesAndCampaigns);
        setPagMov(1);
        setPagPend(1);
    };

    useEffect(() => {
        const delay = setTimeout(() => {
        setIsLoading(false); 
        }, 1000); 

        return () => clearTimeout(delay); 
    }, []);

    const handleClickHowStartAccumulate = () => {
       navigate('/ganhar-saldo');
    };

    const handleClickShowInfoAlert = (item) => {
        setIsPressedItem(item)
        setShowAlertInfo(!showAlertInfo)
    };

    const handleClickCloseInfoAlert = () => {
        setShowAlertInfo(!showAlertInfo)
    };

    const handleClearFilter  = () => {
        setStartDate(null)
        setEndDate(null)
        setIsAccumulatedBalance(false)
        setIsBalanceSpent(false)
        setIsBalanceOfCodesAndCampaigns(false)
        setPagMov(1);
        setPagPend(1);
    };
    
    const handleEnabledBtnFilter = () => {
        return (
            (startDate !== null && endDate !== null) ||
            !!isAccumulatedBalance ||
            !!isBalanceSpent ||
            !!isBalanceOfCodesAndCampaigns
        );
    };
    

    const handlePresets  = (start, end) => {
        setStartDate(start)
        setEndDate(end)
        setPagMov(1);
        setPagPend(1);
    };

    const handleClickOpenInfoDataModal = (item) => {
        setIsPressedItem(item)
        setOpenMovementsInfoModal(true)
    };

    const handleOpenFilterModal = () => {
        setOpenSelectFilteModal(true)
    };

    const renderMovimentsPaymentStatusByItem = (item) => {
        const paymentStatus =  getPaymentStatus(item.movTipo, item.iTransferencia, item.movCodigo);
        return paymentStatus;
    };

    const onHide = () => {
        setOpenSelectFilteModal(false)
    };

    const presets = [
        {
            text: "Ir para hoje",
            start: today,
            end: today,
        },
        {
        text: "Últimos 7 dias",
        start: moment().subtract(1, "week"),
        end: today,
        },
        {
        text: "Últimos 14 dias",
        start: moment().subtract(2, "week"),
        end: today,
        },
        {
        text: "Últimos 30 dias",
        start: moment().subtract(1, "month"),
        end: today,
        },
    ];

    const handkeChangeMaxLength = (text, maxLength) => {
        if (text.length > maxLength) {
            return text.slice(0, maxLength) + '...';
        }
        return text;
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (alertRef.current && !alertRef.current.contains(event.target)) {
                handleClickCloseInfoAlert();
            }
        };

        if (showAlertInfo) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [showAlertInfo, handleClickCloseInfoAlert]);

    const handleBtnGoToContacts = () => {
        navigate('/configuracoes#contactMainContainer');
    };

    return (  
        <>
        <Header/> 
        { isLoading ? 
        <GifAnim />
        :
        <>
        {/* Start fist div componet with title / header */}
        <div className={ isTablet ? "mainViewContainerSeeMovements" : ( isMobile ? 'mainViewContainerSeeMovementsTablet' : 'mainViewContainerSeeMovementsMobile') }>
            <div className={ isTablet ? 'firstTxtViewContainerSeeMovements' : 'firstTxtViewContainerSeeMovementsMobile' }>
                <div style={ isTablet ? { width: '100%', height: '100%', marginBottom: '16px' } : { width: '100%', height: '100%', marginBottom: '16px' }}>
                    { (isStatusCarteira ===  '2')  &&
                        <SuspendedWalletAlert onPress={handleBtnGoToContacts} />
                    }
                </div>   
                <div className='mainHeadingViewContainerPartnersPage'>           
                    <CustomBreadcrumbs hasPadding={isTablet ? true : false} hasMoviments />
                    <Heading hasBtnBack={false} hasPadding={isTablet ? true : false} />
                </div>                 
                {/* End fist div componet with title / header */}

                {/* Start second div componet with balance informations 3 blocks */}
                <div className={ isTablet ? 'mainSecondBoxViewContainerSeeMovements' : 'mainSecondBoxViewContainerSeeMovementsMobile'}>
                    <div className={ isTablet ? 'secondBoxMainContainerSeeMovements' : ( isMobile ? 'secondBoxMainContainerSeeMovementsTablet' : 'secondBoxMainContainerSeeMovementsMobile') }>
                        <div className={ isTablet ? 'mainBoxViewContainerSeeMovements' : ( isMobile ? 'mainBoxViewContainerSeeMovementsTablet' : 'mainBoxViewContainerSeeMovementsMobile') }>
                            <div className='rowMainBoxViewContainerSeeMovements'>
                                <div className="personIconViewSeeMovements">
                                    <img src={ImgMovSaldoDispSvg} alt="icon" className="personIconSeeMovements" />
                                </div>
                                <div className="txtPersonIconTitleSeeMovements">Saldo disponível</div>
                            </div>
                            <div className='secondRowMainBoxViewContainerSeeMovements'>
                                <div  className="txtExtraViewContainerSaldoPersonSeeMovements">
                                    <div className="textTitleRegularSeeMovementsWithSaldoMobile">{saldoDisp}€</div>
                                </div>
                                <div className='colunmBoxViewContainerSeeMovements'>
                                    <div className="txtExtraSaldoBigerPersonSeeMovements">+ {saldoPend}€</div>
                                    <div className="txtExtraSaldoPersonSeeMovements">Saldo pendente</div>
                                </div>
                            </div>
                        </div>
                        <div className={ isTablet ? 'mainBoxViewContainerSeeMovements' : ( isMobile ? 'mainBoxViewContainerSeeMovementsTablet' : 'mainBoxViewContainerSeeMovementsMobile') }>
                            <div className='rowMainBoxViewContainerSeeMovements'>
                                    <div className="personIconViewSeeMovements">
                                        <img src={ImgMovAcumuladoSempreSvg} alt="icon" className="personIconSeeMovements" />
                                    </div>
                                    <div className="txtPersonIconTitleSeeMovements">Acumulado desde sempre</div>
                            </div>
                            <div className='secondRowMainBoxViewContainerSeeMovements'>
                                <div className="textTitleRegularSeeMovementsWithSaldoMobile">{saldoAcum}€</div>
                            </div>
                        </div>
                        <div className={ isTablet ? 'mainBoxViewContainerSeeMovements' : ( isMobile ? 'mainBoxViewContainerSeeMovementsTablet' : 'mainBoxViewContainerSeeMovementsMobile') }>
                            <div className='rowMainBoxViewContainerSeeMovements'>
                                <div className="personIconViewSeeMovements">
                                    <img src={ImgMovOndeMaisAcumulouSvg} alt="icon" className="personIconSeeMovements" />
                                </div>
                                <div className="txtPersonIconTitleSeeMovements">Onde mais acumulou</div>
                            </div>
                            <div className={ isTablet ? 'secondRowMainBoxViewContainerSeeMovements' : ( isMobile ? 'secondRowMainBoxViewContainerSeeMovements' : 'colunmBoxStartViewContainerSeeMovementsMobile' )}>
                                {saldoTopAcumDesc.length > 26 ?
                                    <>
                                        <div className={!isMobile ? "textTitleRegularSmallSeeMovementsWithSaldoMobile" : "textTitleRegularSmallSeeMovementsWithSaldo"} >{handkeChangeMaxLength(saldoTopAcumDesc, 26)}</div>

                                        <div className='alertHoverInfoMainViewSeeMovements'>
                                            <div className='mainViewAlerSmModalSeeMovements'>
                                                <div className='txtAlerSmModalSeeMovements'>{saldoTopAcumDesc}</div>
                                            </div>
                                        </div>
                                    </>
                                : 
                                    <div className={!isMobile ? "textTitleRegularSmallSeeMovementsWithSaldoMobile" : "textTitleRegularSmallSeeMovementsWithSaldo"} >{handkeChangeMaxLength(saldoTopAcumDesc, 26)}</div>
                                }
                                <div className={!isMobile ? 'colunmBoxViewContainerSeeMovementsMobile' : 'colunmBoxViewContainerSeeMovements'}>
                                    <div className="txtExtraSaldoBigerPersonSeeMovements">{saldoTopAcum}€</div>
                                    <div className="txtExtraSaldoPersonSeeMovements">Total acumulado</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* End second div componet with balance informations 3 blocks */}

                {/* Start Mobile div componet with filters */}

                { ( !isTablet && (listaMovimentosResp?.length > 0 || listaMovimentosPendResp?.length > 0)) && (
                        <>
                        <div className='mainFilterColumnViewContainerSeeMovementsMobile'>
                            <div className='firstOptionsFormChekedViewSeeMovements'>
                                <div className='txtFirstOptionsTitleSeeMovements'>Pesquise os seus movimentos</div>
                                <div className='txtInfoGrennOptionsRegularTitleSeeMovements'>
                                    <span className='txtInfoGrennOptionsBoldTitleSeeMovements'>{selectedOption === 'M' ? numeroDeOcorrenciasMov : numeroDeOcorrenciasPend} </span>
                                    <span className='txtInfoGrennOptionsRegularTitlePartnersPage'> resultados encontrados. Use os filtros para refinar melhor a sua pesquisa</span>
                                </div>
                                {/* <div className='txtFirstOptionsSubTitleSeeMovements'>Filtre por tipo ou por data</div> */}
                            </div>
                            <div className='firstSubMainContainerSeeMovements'>
                                <CustomButton 
                                    text={'Filtrar'} 
                                    textColor={'#00214D'}
                                    onPress={handleOpenFilterModal} 
                                    borderColor={'#00214D'}
                                    hasArrow
                                    iconColor={'#00214D'}
                                    iconType={'filter'}
                                    hasShadow={false}
                                />

                                <Modal
                                    size="lg-down"
                                    fullscreen
                                    aria-labelledby="contained-modal-title-vcenter"
                                    centered
                                    className="modalMainContainerMovementsInfoSeeMovementsMobile "
                                    show={openSelectFilteModal}
                                >
                                    <div className='contentViewCustomModalSelectFilterMobile'>
                                        <div className='txtFirstOptionsTitleMainViewRowSeeMovementsMobile'>
                                            <div className='txtFirstOptionsTitleViewRowSeeMovementsMobile'>
                                                <div className='txtFirstOptionsTitleSeeMovements'>Filtrar</div>
                                                <button className='btnFirstOptionsTitleSeeMovementsMobile' onClick={onHide}><IoMdClose className="closeIconSeeMovementsMobile"/></button>
                                            </div>
                                        </div>
                                        <div className='contentViewCustomModalScrollSelectFilterMobile'>
                                            <div className='txtInfoGrennOptionsRegularTitleSeeMovements'>
                                                <span className='txtInfoGrennOptionsBoldTitleSeeMovementsFilterMobile'>{selectedOption === 'M' ? numeroDeOcorrenciasMov : numeroDeOcorrenciasPend} </span>
                                                <span className='txtInfoGrennOptionsRegularTitleSeeMovementsFilterMobile'> resultados encontrados. Use os filtros para refinar melhor a sua pesquisa</span>
                                            </div>
                                            <div className='optionsDeviderLineSeeMovements'></div>
                                            <div className='txtFirstOptionsTitleViewSeeMovements'>
                                                <div style={{ marginBottom: '16px'}}>
                                                    <div className='txtFirstOptionsTitleSeeMovements'>Por tipo</div>
                                                </div>
                                                <Form>
                                                    <div className='firstOptionsFormChekedViewSeeMovements'>
                                                        <div className='firstOptionsRowFormChekedViewSeeMovements'>
                                                            <Form.Check 
                                                                type="checkbox" 
                                                                label={''}
                                                                checked={isAccumulatedBalance}
                                                                onChange={handleCheckboxChangeOne}
                                                                disabled={filtroAcumulado <= '0'}
                                                            />
                                                            <div 
                                                                className='txtFormSeeMovements' 
                                                                onClick={filtroAcumulado > 0 ? handleCheckboxChangeOne : null} 
                                                                style={{ cursor: filtroAcumulado > 0 ? 'pointer' :  'default'}}>
                                                                    {`Saldo acumulado (${filtroAcumulado})`}
                                                                </div>
                                                        </div>
                                                        <div className='firstOptionsRowFormChekedViewSeeMovements'>
                                                            <Form.Check 
                                                                type="checkbox" 
                                                                label={''}
                                                                checked={isBalanceSpent}
                                                                onChange={handleCheckboxChangeTwo}
                                                                disabled={filtroGasto <= '0'}
                                                            />
                                                            <div 
                                                                className='txtFormSeeMovements' 
                                                                onClick={filtroGasto > 0 ? handleCheckboxChangeTwo : null} 
                                                                style={{ cursor: filtroCodigo > 0 ? 'pointer' :  'default'}}>
                                                                    {`Saldo gasto (${filtroGasto})`}
                                                            </div>
                                                        </div>
                                                        <div className='firstOptionsRowFormChekedViewSeeMovements'>
                                                            <Form.Check 
                                                                type="checkbox" 
                                                                label={''}
                                                                checked={isBalanceOfCodesAndCampaigns}
                                                                onChange={handleCheckboxChangeThree}
                                                                disabled={filtroCodigo <= '0'}
                                                            />
                                                            <div 
                                                                className='txtFormSeeMovements' 
                                                                onClick={filtroCodigo > 0 ? handleCheckboxChangeThree : null}
                                                                style={{ cursor: filtroCodigo > 0 ? 'pointer' :  'default'}}>
                                                                    {`Saldo de códigos e campanhas (${filtroCodigo})`}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Form>
                                            </div>
                                            <div className='optionsDeviderLineSeeMovements'></div>
                                            <div className='txtFirstOptionsTitleViewSeeMovements'>
                                                <div style={{ marginBottom: '16px'}}>
                                                    <div className='txtFirstOptionsTitleSeeMovements'>Por data</div>
                                                </div>
                                                <div className={ isTablet ? 'datePickerViewContainerSeeMovements' : ( isUltraMobile ? 'datePickerViewContainerSeeMovements' : 'datePickerViewColumnContainerSeeMovements' ) }>
                                                    <CustomDatePicker 
                                                        value={startDate} 
                                                        onChange={setStartDate} 
                                                        label="Data de início" 
                                                    />
                                                    <CustomDatePicker 
                                                        value={endDate} 
                                                        onChange={setEndDate} 
                                                        label="Data de fim" 
                                                    />
                                                </div>
                                            </div>
                                            <div className='optionsDeviderLineSeeMovements'></div>
                                            {/* <div style={{ marginTop: '-16px' }}>
                                                {presets.map(({ text, start, end }) => {
                                                    const isChosen =
                                                    moment(start).format(dateFormat) ===
                                                        moment(startDate).format(dateFormat) &&
                                                    moment(end).format(dateFormat) ===
                                                        moment(endDate).format(dateFormat);
                                                    return (
                                                        <CustomButton 
                                                            key={text}
                                                            text={text} 
                                                            textColor={'#00214D'}
                                                            onPress={() => handlePresets(start, end)} 
                                                            hasSubLine
                                                            borderColor={'#00214D'}
                                                            hasArrow={true}
                                                            iconColor={'#00214D'}
                                                            iconType={'calendar'}
                                                        />
                                                    );
                                                })}
                                            </div>
                                            <div className='optionsDeviderLineSeeMovements'></div> */}
                                        </div>
                                        <div className='txtFirstOptionsTitleMainViewRowSeeMovementsMobile'>
                                            <div className='fotterMobalBtnViewSeeMovementsMobile' style={{ paddingTop: '32px'}}>
                                                <CustomButton 
                                                    text={'Remover filtros'} 
                                                    textColor={'#00214D'}
                                                    onPress={handleClearFilter} 
                                                    enabled={handleEnabledBtnFilter()}
                                                    color={'#fff'}
                                                    borderColor={'#00214D'}
                                                    isSmall
                                                />
                                                <CustomButton 
                                                    text={'Aplicar filtros'} 
                                                    color={'#15D4B6'}
                                                    textColor={'#00214D'}
                                                    onPress={onHide}
                                                    enabled={handleEnabledBtnFilter()}
                                                    isSmall
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </Modal>
        
                            </div>

                        </div>
                        </>
                )}

                {/* End Mobile div componet with filters */}

                {/* Start third div componet with swith selector */}
                <div className={ isTablet ? 'secondMainContainerSeeMovements' : 'secondMainContainerSeeMovementsMobile' }>
                    { isTablet ?
                        <div className='swithSelectorContainerSeeMovements' style={{ marginBottom: '48px' }}>
                            <CustomButtonSelectOption 
                                text={'Movimentos'} 
                                onPress={() => handleOptionClick("M")} 
                                isActive={selectedOption === 'M'}
                            />
                            <CustomButtonSelectOption 
                                text={'Pendentes'} 
                                onPress={() => handleOptionClick("P")} 
                                isActive={selectedOption === 'P'}
                            />
                        </div>
                        : ( isMobile ?
                            <div className='swithSelectorContainerSeeMovementsMobile' style={{ marginBottom: '48px' }}>
                                <CustomButtonSelectOption 
                                    text={'Movimentos'} 
                                    onPress={() => handleOptionClick("M")} 
                                    isActive={selectedOption === 'M'}
                                />
                                <CustomButtonSelectOption 
                                    text={'Pendentes'} 
                                    onPress={() => handleOptionClick("P")} 
                                    isActive={selectedOption === 'P'}
                                />
                            </div>
                        :
                            <CustomButtonSelectOptionView 
                                options={options} 
                                optionText={optionText}
                                onOptionChange={handleOptionClick}
                            />
                        )
                    }      

                    {/* End third div componet with swith selector */}

                    <div className={ isTablet ? 'firstSubMainContainerSeeMovements' : 'firstSubMainContainerSeeMovementsMobile' }>
                        <div className='mainOptionsViewContainerSeeMovements'>
                            {/* Start fourth div componet with filters */}
                            { isTablet && (
                                <>
                                <div className='mainOptionsColumnViewContainerSeeMovements'>
                                    <div className='txtFirstOptionsTitleViewSeeMovements'>
                                        <div style={{ marginBottom: '30px'}}>
                                            <div className='txtFirstOptionsTitleSeeMovements'>
                                                { isLoading ? <PlaceholderLoading shape="rect" width={250} height={20}/> : 'Pesquise os seus movimentos' }
                                            </div>
                                        </div>
                                        {  (listaMovimentosResp?.length > 0 || listaMovimentosPendResp?.length > 0) &&  (
                                            isLoading 
                                            ? 
                                                <PlaceholderLoading shape="rect" width={250} height={20}/> 
                                            : 
                                                <div className='txtInfoGrennOptionsRegularTitleSeeMovements'>
                                                    <span className='txtInfoGrennOptionsBoldTitleSeeMovements'>{selectedOption === 'M' ? numeroDeOcorrenciasMov : numeroDeOcorrenciasPend} </span>
                                                    <span className='txtInfoGrennOptionsRegularTitlePartnersPage'> resultados encontrados. Use os filtros para refinar melhor a sua pesquisa</span>
                                                </div>
                                        )}
                                    </div>
                                    <div className='optionsDeviderLineSeeMovements'></div>
                                    <div className='txtFirstOptionsTitleViewSeeMovements'>
                                        <div style={{ marginBottom: '16px'}}>
                                            <div className='txtFirstOptionsTitleSeeMovements'>
                                                { isLoading ? <PlaceholderLoading shape="rect" width={250} height={20}/> : 'Por tipo'}
                                            </div>
                                        </div>
                                        <Form>
                                            { isLoading ? <PlaceholderLoading shape="rect" width={350} height={75}/> : (
                                            <>
                                            <div className='firstOptionsFormChekedViewSeeMovements'>
                                                <div className='firstOptionsRowFormChekedViewSeeMovements'>
                                                    <Form.Check 
                                                        type="checkbox" 
                                                        label={''}
                                                        checked={isAccumulatedBalance}
                                                        onChange={handleCheckboxChangeOne}
                                                        disabled={filtroAcumulado <= '0'}
                                                    />
                                                    <div 
                                                        className='txtFormSeeMovements' 
                                                        onClick={filtroAcumulado > 0 ? handleCheckboxChangeOne : null} 
                                                        style={{ cursor: filtroAcumulado > 0 ? 'pointer' :  'default'}}>
                                                            {`Saldo acumulado (${filtroAcumulado})`}
                                                        </div>
                                                </div>
                                                <div className='firstOptionsRowFormChekedViewSeeMovements'>
                                                    <Form.Check 
                                                        type="checkbox" 
                                                        label={''}
                                                        checked={isBalanceSpent}
                                                        onChange={handleCheckboxChangeTwo}
                                                        disabled={filtroGasto <= '0'}
                                                    />
                                                    <div 
                                                        className='txtFormSeeMovements' 
                                                        onClick={filtroGasto > 0 ? handleCheckboxChangeTwo : null} 
                                                        style={{ cursor: filtroCodigo > 0 ? 'pointer' :  'default'}}>
                                                            {`Saldo gasto (${filtroGasto})`}
                                                    </div>
                                                </div>
                                                <div className='firstOptionsRowFormChekedViewSeeMovements'>
                                                    <Form.Check 
                                                        type="checkbox" 
                                                        label={''}
                                                        checked={isBalanceOfCodesAndCampaigns}
                                                        onChange={handleCheckboxChangeThree}
                                                        disabled={filtroCodigo <= '0'}
                                                    />
                                                    <div 
                                                        className='txtFormSeeMovements' 
                                                        onClick={filtroCodigo > 0 ? handleCheckboxChangeThree : null}
                                                        style={{ cursor: filtroCodigo > 0 ? 'pointer' :  'default'}}>
                                                            {`Saldo de códigos e campanhas (${filtroCodigo})`}
                                                    </div>
                                                </div>
                                            </div>
                                            </>
                                            )}
                                        </Form>
                                    </div>
                                    <div className='optionsDeviderLineSeeMovements'></div>
                                    <div className='txtFirstOptionsTitleViewSeeMovements'>
                                        <div style={{ marginBottom: '16px'}}>
                                            <div className='txtFirstOptionsTitleSeeMovements'>
                                                { isLoading ? <PlaceholderLoading shape="rect" width={150} height={20}/> : 'Por data'}
                                            </div>
                                        </div>
                                        <div>
                                            { isLoading ? <PlaceholderLoading shape="rect" width={150} height={25}/> : (
                                                <div className='datePickerViewContainerSeeMovements'>
                                                    <CustomDatePicker 
                                                        value={startDate} 
                                                        onChange={setStartDate} 
                                                        label="Dat de início" 
                                                    />
                                                    <CustomDatePicker 
                                                        value={endDate} 
                                                        onChange={setEndDate} 
                                                        label="Data de fim" 
                                                    />
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                    <div className='optionsDeviderLineSeeMovements'></div>
                                    { isLoading ? <PlaceholderLoading shape="rect" width={150} height={50}/> : (
                                    <>
                                        <CustomButton 
                                            text={'Remover filtros'} 
                                            textColor={'#00214D'}
                                            onPress={handleClearFilter} 
                                            color={'#fff'}
                                            enabled={handleEnabledBtnFilter()}
                                            borderColor={'#00214D'}
                                            hasShadow={false}
                                        />
                                        <div style={{ marginTop: '-16px' }}>
                                            <DatePresets
                                                startDate={startDate}
                                                endDate={endDate}
                                                dateFormat={dateFormat}
                                                handlePresets={(start, end) => {
                                                setStartDate(start);
                                                setEndDate(end);
                                            }}
                                            />
                                        </div>
                                    </>
                                    )}
                                </div>
                                </>
                            )}
                            {/* End fourth div componet with filters */}

                            {/* Start fifth div componet with info blocks list */}
                            { selectedOption === 'M' && (
                            <div className={ listaMovimentosResp?.length > 0 ? 'mainOptionsSecondColumnViewContainerSeeMovements' : 'mainOptionsSecondColumnViewNoDataContainerSeeMovements' }>
                                <>
                                { processedItems?.length > 0 ? (
                                    processedItems.map((item, index) => (
                                    <div style={{ width:'100%', maxHeight:'100%', display:'flex', flexDirection:'column' }} key={index}>
                                        { isLoading ? <PlaceholderLoading shape="rect" width={350} height={50}/> : (
                                        <>
                                        {item.shouldDisplayDate && (
                                            <div className='iconDotainOptionsSecondColumnViewContainerSeeMovements'><GoDotFill className='iconDotainOptionsSecondColumnSeeMovements' /></div>
                                        )}
                                        <div className={ isTablet ? 'mainDataBigBoxViewContainerSeeMovements' : 'mainDataBigBoxViewContainerSeeMovementsMobile' }>
                                            {/* <div className={ isTablet ? 'txtFirstOptionsTitleSeeMovementsMobile' : 'txtFirstOptionsTitleSeeMovementsMobile'}>{moment(item.movData).format('LL')}</div> */}
                                            {item.shouldDisplayDate && (
                                                <div className={isTablet ? 'txtFirstOptionsTitleSeeMovementsMobile' : 'txtFirstOptionsTitleSeeMovementsMobile'}>
                                                    {item.formattedDate}
                                                </div>
                                            )}
                                            <div className={ isTablet ? 'mainDataBoxViewContainerSeeMovements' : 'mainDataBoxViewContainerSeeMovementsMobile'}>
                                                <div className='rowDataBoxViewContainerSeeMovements'>
                                                    <div className="txtFirstOptionsSmallTitleSeeMovementsMobile">{moment(item.movData).format('LL')}</div>
                                                    <div className="personIconViewSeeMovements">
                                                        <button className='btnViewOpenInfoDataModalIconSeeMovements'  type='button' onClick={ () => handleClickOpenInfoDataModal(item)}>
                                                            <FaAngleRight className='openInfoDataModalIconSeeMovements' />
                                                        </button>
                                                        <CustomModalMovementsInfo 
                                                            title={renderMovimentsPaymentStatusByItem(item)?.title}
                                                            txtAlert={renderMovimentsPaymentStatusByItem(item)?.txtAlert}
                                                            date={moment(item.movData).format('LL')}
                                                            amountAcumulated={currencyFormat(item.movValor)}
                                                            partnerName={item.movNomeParceiro}
                                                            show={ isPressedItem === item ? openMovementsInfoModal : null} 
                                                            amountPaid={currencyFormat(item.movValorCompra)}
                                                            isPending={item.movTipo}
                                                            onHide={() => setOpenMovementsInfoModal(false)} 
                                                            txtDetalhe={renderMovimentsPaymentStatusByItem(item)?.txtDetalheDeMovimentos}
                                                            txtPromoCode={item.movCodigo}
                                                            txtDetalheCupao={renderMovimentsPaymentStatusByItem(item)?.txtDetalheDeMovimentosCupao}
                                                            txtDetalheMP={renderMovimentsPaymentStatusByItem(item)?.txtDetalheDeMovimentosMP}
                                                            movPlataforma={item.movPlataforma}
                                                            movEncomenda={item.movEncomenda}
                                                            iTransferencia={item.iTransferencia}
                                                        /> 
                                                    </div>
                                                </div>
                                                <div className='mainTitleDataBoxViewSeeMovements'>
                                                    <div className={ isTablet ? 'txtFirstOptionsTitleDescSeeMovements' : 'txtFirstOptionsBoxTitleSeeMovementsMobile'}>{item.movDesc}</div>
                                                </div>
                                                <div className='rowDataBoxViewContainerSeeMovements'>
                                                        <button className='mainModalInfoStatusDataBoxViewSeeMovements' style={{ background:renderMovimentsPaymentStatusByItem(item)?.color}} type='button' onClick={ () => handleClickShowInfoAlert(item)} >
                                                            <div className='iconModalInfoStatusDataBoxSeeMovements' style={{ color:renderMovimentsPaymentStatusByItem(item)?.iconColor}} ><GoDotFill /></div>
                                                            <div className={ isTablet ? 'txtModalInfoStatusDataBoxSeeMovements' : 'txtModalInfoStatusDataBoxSeeMovementsMobile'}>{renderMovimentsPaymentStatusByItem(item)?.title}</div>
                                                            <div className='iconInfoViewModalInfoStatusDataBoxSeeMovements'>
                                                                <IoMdInformationCircleOutline className='iconInfoModalInfoStatusDataBoxSeeMovements' />
                                                            </div>
                                                        </button>
                                                        { (isPressedItem === item && showAlertInfo) &&
                                                            <div className='alertInfoMainViewSeeMovements' ref={alertRef}  onClick={handleClickCloseInfoAlert}>
                                                                <div className='mainViewAlerSmModalSeeMovements'>
                                                                    <div className='txtTitleAlerSmModalSeeMovements'>{renderMovimentsPaymentStatusByItem(item)?.title}</div>
                                                                    <div className='txtAlerSmModalSeeMovements'>{item.movFrase}</div>
                                                                </div>
                                                            </div>
                                                        }
                                                                    
                                                    <div className='textTitleRegularBoxSeeMovementsWithSaldoMobile'>{currencyFormat(item.movValor)}€</div>
                                                </div>
                                            </div>
                                        </div>
                                        </>
                                        )}
                                    </div>   
                                ))
                                ) : (
                                    <div className={ isTablet ? 'noDataViewContainerSeeMovements' : ( isMobile ? 'noDataViewContainerSeeMovements' : 'noDataViewContainerSeeMovementsMobile' )}>
                                        { isLoading ? <PlaceholderLoading shape="rect" width={350} height={50}/> : (
                                        <>
                                            <div className='txtNoMovementContentColumnViewContainerSeeMovements'>
                                                <div className="noMovementDataIconViewSeeMovements">
                                                    <img src={ImgNoMovementsDataSvg} alt="icon" className="noMovementDataIconSeeMovements" />
                                                </div>
                                                <div className='txtFirstOptionsTitleSeeMovements'>Não há movimentos para mostrar</div>
                                                <div className='txtNoMovementColumnViewContainerSeeMovements'>
                                                    <div className='txtNoMovementSmallSeeMovements'>Tem algum filtro aplicado? Remova todos os filtros de pesquisa.</div>
                                                    <div className='txtNoMovementSmallSeeMovements'>Ainda não acumulou saldo? Veja como começar a a acumular.</div>
                                                </div>
                                            </div>
                                            <div className='txtNoMovementBtnColumnViewContainerSeeMovements'>
                                                <CustomButton 
                                                    text={'Remover filtros'} 
                                                    textColor={'#00214D'}
                                                    onPress={handleClearFilter} 
                                                    color={'#fff'}
                                                    enabled={handleEnabledBtnFilter()}
                                                    borderColor={'#00214D'}
                                                    hasShadow={false}
                                                />
                                                <div className={ isTablet ? 'divBtnSaltarSeeMovements' : ( isMobile ? 'divBtnSaltarSeeMovementsStackTablet' : 'divBtnSaltarSeeMovementsMobile' )}>
                                                    <CustomButton 
                                                        text={'Acumular saldo'} 
                                                        textColor={'#00214D'}
                                                        onPress={handleClickHowStartAccumulate} 
                                                        hasSubLine
                                                        hasSubLineSmall
                                                        hasSubLineSmallColor={'#00214D'}
                                                    />
                                                </div>
                                            </div>
                                        </>
                                        )}
                                    </div>
                                )}
                                { (listaMovimentosResp?.length > 0 && numeroDePaginasMov > 1) && (
                                    <ListPagination numPage={numeroDePaginasMov} pageNumber={pagMov} setPageSelected={setPagMov}/>
                                )}
                                </>
                            </div>
                            )}

                            { selectedOption === 'P' && (
                            <div className={ listaMovimentosPendResp?.length > 0 ? 'mainOptionsSecondColumnViewContainerSeeMovements' : 'mainOptionsSecondColumnViewNoDataContainerSeeMovements' }>
                                <>
                                { processedItemsPend?.length > 0 ? (
                                    processedItemsPend.map((item, index) => (
                                    <div style={{ width:'100%', maxHeight:'100%', display:'flex', flexDirection:'column' }} key={index}>
                                        { isLoading ? <PlaceholderLoading shape="rect" width={350} height={50}/> : (
                                        <>
                                        {item.shouldDisplayDate && (
                                            <div className='iconDotainOptionsSecondColumnViewContainerSeeMovements'><GoDotFill className='iconDotainOptionsSecondColumnSeeMovements' /></div>
                                        )}
                                        <div className={ isTablet ? 'mainDataBigBoxViewContainerSeeMovements' : 'mainDataBigBoxViewContainerSeeMovementsMobile' }>
                                            {/* <div className={ isTablet ? 'txtFirstOptionsTitleSeeMovements' : 'txtFirstOptionsTitleSeeMovementsMobile'}>{moment(item.movData).format('LL')}</div> */}
                                            {item.shouldDisplayDate && (
                                                <div className={isTablet ? 'txtFirstOptionsTitleSeeMovementsMobile' : 'txtFirstOptionsTitleSeeMovementsMobile'}>
                                                    {item.formattedDate}
                                                </div>
                                            )}
                                            <div className={ isTablet ? 'mainDataBoxViewContainerSeeMovements' : 'mainDataBoxViewContainerSeeMovementsMobile'}>
                                                <div className='rowDataBoxViewContainerSeeMovements'>
                                                    <div className="txtFirstOptionsSmallTitleSeeMovementsMobile">{moment(item.movData).format('LL')}</div>
                                                    <div className="personIconViewSeeMovements">
                                                        <button className='btnViewOpenInfoDataModalIconSeeMovements'  type='button' onClick={ () => handleClickOpenInfoDataModal(item)}>
                                                            <FaAngleRight className='openInfoDataModalIconSeeMovements' />
                                                        </button>
                                                        <CustomModalMovementsInfo 
                                                            title={renderMovimentsPaymentStatusByItem(item)?.title}
                                                            txtAlert={renderMovimentsPaymentStatusByItem(item)?.txtAlert}
                                                            date={moment(item.movData).format('LL')}
                                                            amountAcumulated={currencyFormat(item.movValor)}
                                                            partnerName={item.movNomeParceiro}
                                                            show={ isPressedItem === item ? openMovementsInfoModal : null} 
                                                            amountPaid={currencyFormat(item.movValorCompra)}
                                                            isPending={item.movTipo}
                                                            onHide={() => setOpenMovementsInfoModal(false)} 
                                                            txtDetalhe={renderMovimentsPaymentStatusByItem(item)?.txtDetalheDeMovimentos}
                                                            txtPromoCode={item.movCodigo}
                                                            txtDetalheCupao={renderMovimentsPaymentStatusByItem(item)?.txtDetalheDeMovimentosCupao}
                                                            txtDetalheMP={renderMovimentsPaymentStatusByItem(item)?.txtDetalheDeMovimentosMP}
                                                            movPlataforma={item.movPlataforma}
                                                            movEncomenda={item.movEncomenda}
                                                            iTransferencia={item.iTransferencia}
                                                        /> 
                                                    </div>
                                                </div>
                                                <div className='mainTitleDataBoxViewSeeMovements'>
                                                    <div className={ isTablet ? 'txtFirstOptionsTitleDescSeeMovements' : 'txtFirstOptionsBoxTitleSeeMovementsMobile'}>{item.movDesc}</div>
                                                </div>
                                                <div className='rowDataBoxViewContainerSeeMovements'>
                                                        <button className='mainModalInfoStatusDataBoxViewSeeMovements' style={{ background:renderMovimentsPaymentStatusByItem(item)?.color}} type='button' onClick={ () => handleClickShowInfoAlert(item)} >
                                                            <div className='iconModalInfoStatusDataBoxSeeMovements' style={{ color:renderMovimentsPaymentStatusByItem(item)?.iconColor}} ><GoDotFill /></div>
                                                            <div className={ isTablet ? 'txtModalInfoStatusDataBoxSeeMovements' : 'txtModalInfoStatusDataBoxSeeMovementsMobile'}>{renderMovimentsPaymentStatusByItem(item)?.title}</div>
                                                            <div className='iconInfoViewModalInfoStatusDataBoxSeeMovements'>
                                                                <IoMdInformationCircleOutline className='iconInfoModalInfoStatusDataBoxSeeMovements' />
                                                            </div>
                                                        </button>
                                                        { (isPressedItem === item && showAlertInfo) &&
                                                            <div className='alertInfoMainViewSeeMovements' ref={alertRef} onClick={handleClickCloseInfoAlert}>
                                                                <div className='mainViewAlerSmModalSeeMovements'>
                                                                    <div className='txtTitleAlerSmModalSeeMovements'>{renderMovimentsPaymentStatusByItem(item)?.title}</div>
                                                                    <div className='txtAlerSmModalSeeMovements'>{item.movFrase}</div>
                                                                </div>
                                                            </div>
                                                        }
                                                                    
                                                    <div className='textTitleRegularBoxSeeMovementsWithSaldoMobile'>{currencyFormat(item.movValor)}€</div>
                                                </div>
                                            </div>
                                        </div>
                                        </>
                                        )}
                                    </div>
                                ))
                                ) : (
                                    <div className={ isTablet ? 'noDataViewContainerSeeMovements' : ( isMobile ? 'noDataViewContainerSeeMovements' : 'noDataViewContainerSeeMovementsMobile' )}>
                                        { isLoading ? <PlaceholderLoading shape="rect" width={350} height={50}/> : (
                                        <>
                                            <div className='txtNoMovementContentColumnViewContainerSeeMovements'>
                                                <div className="noMovementDataIconViewSeeMovements">
                                                    <img src={ImgNoMovementsDataSvg} alt="icon" className="noMovementDataIconSeeMovements" />
                                                </div>
                                                <div className='txtFirstOptionsTitleSeeMovements'>Não há movimentos para mostrar</div>
                                                <div className='txtNoMovementColumnViewContainerSeeMovements'>
                                                    <div className='txtNoMovementSmallSeeMovements'>Tem algum filtro aplicado? Remova todos os filtros de pesquisa.</div>
                                                    <div className='txtNoMovementSmallSeeMovements'>Ainda não acumulou saldo? Veja como começar a a acumular.</div>
                                                </div>
                                            </div>
                                            <div className='txtNoMovementBtnColumnViewContainerSeeMovements'>
                                                <CustomButton 
                                                    text={'Remover filtros'} 
                                                    textColor={'#00214D'}
                                                    onPress={handleClearFilter} 
                                                    color={'#fff'}
                                                    enabled={handleEnabledBtnFilter()}
                                                    borderColor={'#00214D'}
                                                    hasShadow={false}
                                                />
                                                <div className={ isTablet ? 'divBtnSaltarSeeMovements' : ( isMobile ? 'divBtnSaltarSeeMovementsStackTablet' : 'divBtnSaltarSeeMovementsMobile' )}>
                                                    <CustomButton 
                                                        text={'Acumular saldo'} 
                                                        textColor={'#00214D'}
                                                        onPress={handleClickHowStartAccumulate} 
                                                        hasSubLine
                                                        hasSubLineSmall
                                                        hasSubLineSmallColor={'#00214D'}
                                                    />
                                                </div>
                                            </div>
                                        </>
                                        )}
                                    </div>
                                )}
                                {(listaMovimentosPendResp?.length > 0 && numeroDePaginasPend > 1) && (
                                    <ListPagination numPage={numeroDePaginasPend} pageNumber={pagPend} setPageSelected={setPagPend}/>
                                )}
                                </>
                            </div>   
                            )}
                            
                            {/* End fifth div componet with info blocks list */}
                        </div>                    
                    </div>
                </div>   
            </div>
        </div>
        </>
        }
        <Footer/> 
        </>
    )
}

export default SeeMovements;